export default __webpack_public_path__ + "static/media/1992.4262ae7c.png";